import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TrainingTypeServiceInterface } from './training-type.interface';

@Injectable({
  providedIn: 'root'
})
export class TrainingTypeService implements TrainingTypeServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetAllTrainingTypes(isFrench: boolean): Observable<any[]>{
    return this.httpClient.get<any>(environment.apiBaseUrl + `util/AllTrainingTypes`);
  }
}
